import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import SignIn from './pages/SignIn';

function App() {
  const location = useLocation();
  const isSignInPage = location.pathname === '/signin';

  return (
    <div className="min-h-screen flex flex-col">
      {!isSignInPage && <Header />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signin" element={<SignIn />} />
        </Routes>
      </main>
      {!isSignInPage && <Footer />}
    </div>
  );
}

export default App;
